import { render } from "./NoteSection.vue?vue&type=template&id=4fcd3fb2&ts=true"
import script from "./NoteSection.vue?vue&type=script&lang=ts"
export * from "./NoteSection.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__